export function PatternsV() {

    return {
        name: [
            'shutterstock-520138543-[Converted]',
            'V_abstarct-dark-Transparent',
            'V_abstarct-Gold-and-purplet',
            'V_abstarct-pink',
            'V_abstarct-transparent',
            'V_Abstract-black',
            'V_Abstract-gold',
            'V_Big1',
            'V_Big2',
            'V_Big3',
            'V_Big4',
            'V_Big5',
            'V_Big6',
            'V_Big7',
            'V_Big8',
            'V_Big9',
            'V_Big10',
            'V_Big11',
            'V_Big12',
            'V_Gray-and-greent',
            'V_oranget'
        ]
    }
}